import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { UserService } from 'src/app/_services/user.service';
import { environment } from 'src/environments/environment';
import { GlobalService } from 'src/app/_services/global.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { TranslateService } from '@ngx-translate/core';
import { CustomValidators } from 'src/app/shared/custom-validators';
import { CountryService } from 'src/app/_services/country.service';

declare var $: any;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  // this component's own file input — never look it up by id, school-info uses the
  // same id and getElementById would hand us whichever comes first in the document
  @ViewChild('fileUploadInput') fileUploadInput: ElementRef<HTMLInputElement>;
  formFlag: string
  tab: string;
  modalTitle: string;
  profileForm: UntypedFormGroup;
  passwordForm: UntypedFormGroup;
  imageFile;
  selectedImage;
  image;
  currentPasswordType: string;
  newPasswordType: string;
  passwordError;
  roles;
  //  = ['school_admin', 'teacher', 'bus_driver', 'supervisor', 'security', 'parent'];
  currentUserKeys = ['name', 'role_type', 'image_path', 'gender', 'national_id', 'country_code', 'phone', 'email'];
  loading;
  userId;
  currLang;
  countries = [];
  constructor(
    private userService: UserService,
    private translate: TranslateService,
    private globalService: GlobalService,
    private dataService: DataService,
    private countryService: CountryService) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  ngOnInit(): void {
    this.countries = this.countryService.countries;
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    $(document).on('hidden.bs.modal', '#profileModal', () => {
      this.closeModalHandler();
    })

    this.setRoles();
    this.loading = this.globalService.getLoading().subscribe(res => {
      this.loading = res;
    })

    this.loading = false;
    this.userId = localStorage.getItem('userId')
    this.currentPasswordType = 'password';
    this.newPasswordType = 'password';
    this.formFlag = 'view';
    this.translate.get('init').subscribe(res => {
      this.modalTitle = this.translate.instant('profile.profile');
    });
    this.translate.onLangChange.subscribe(res => {
      this.modalTitle = this.translate.instant('profile.profile');
    })
    this.profileForm = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required, Validators.pattern('^[a-zA-Z ^[\u0621-\u064A\u0660-\u0669 ]+$]*$')]),
      national_id: new UntypedFormControl('', [Validators.required, Validators.pattern('[a-zA-Z0-9]*')]),
      role_type: new UntypedFormControl('', Validators.required),
      country_code: new UntypedFormControl('', Validators.required),
      phone: new UntypedFormControl('', [Validators.required, Validators.pattern('[0-9]*')]),
      email: new UntypedFormControl('', [Validators.email, Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]),
      gender: new UntypedFormControl('', Validators.required)
    })

    this.passwordForm = new UntypedFormGroup({
      old_password: new UntypedFormControl('', [Validators.required,
        //  Validators.minLength(8),
      // Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!\“#$%&‘()*+,-./:;<=>?@\[\\\]^_`{|}~ ]).{8,}$')
    ]),
      new_password: new UntypedFormControl('', [Validators.required, Validators.minLength(8),
      // Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!\“#$%&‘()*+,-./:;<=>?@\[\\\]^_`{|}~ ]).{8,}$'),
      CustomValidators.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
      CustomValidators.patternValidator(/[a-z]/, { hasSmallCase: true }),
      CustomValidators.patternValidator(/.*[0-9].*/, { hasNumber: true }),
      

    ]),
    })

    $(document).on('shown.bs.modal', '#profileModal', () => {
      this.tab = 'profile';
      this.formFlag = 'view';
      $('#home-tab').tab('show');
      for (const i in this.profileForm.value) {
        this.profileForm.controls[i].setValue(this.dataService.currentUser[i]);
      }
      this.image = environment.img_url + this.dataService.currentUser.image_path;
    })

  }
  setRoles() {
    this.translate.get('init').subscribe(res => {
      this.roles = [
        { name: this.translate.instant('roles.school_admin'), value: 'school_admin' },
        { name: this.translate.instant('roles.manager'), value: 'manager' },
        { name: this.translate.instant('roles.teacher'), value: 'teacher' },
        { name: this.translate.instant('roles.supervisor'), value: 'supervisor' },
        { name: this.translate.instant('roles.parent'), value: 'parent' },
        { name: this.translate.instant('roles.security'), value: 'security' },
        { name: this.translate.instant('roles.gate'), value: 'gate' }
      ]
    });
    this.translate.onLangChange.subscribe(res => {
      this.roles = [
        { name: this.translate.instant('roles.school_admin'), value: 'school_admin' },
        { name: this.translate.instant('roles.manager'), value: 'manager' },
        { name: this.translate.instant('roles.teacher'), value: 'teacher' },
        { name: this.translate.instant('roles.supervisor'), value: 'supervisor' },
        { name: this.translate.instant('roles.security'), value: 'security' },
        { name: this.translate.instant('roles.gate'), value: 'gate' }
      ]
    });
  }
  toggleOldPassword() {
    this.currentPasswordType = this.currentPasswordType === 'text' ? 'password' : 'text';
  }

  toggleNewPassword() {
    this.newPasswordType = this.newPasswordType === 'text' ? 'password' : 'text';
  }

  // display-only: role_type in the form stays the raw backend value
  getRoleLabel(): string {
    const role = this.profileForm?.controls['role_type']?.value;
    if (!role) { return ''; }
    const key = `roles.${role}`;
    const translated = this.translate.instant(key);
    return translated !== key ? translated : role;
  }

  // getRoleName(roleName: string) {
  //   let newRoleName;
  //   newRoleName = roleName.includes('_') ? roleName.replace("_", " ") : roleName;
  //   return newRoleName;
  // }

  // image upload
  changeProfileImage() {
    const fileUpload = this.fileUploadInput?.nativeElement;
    if (!fileUpload) {
      return;
    }
    // clearing the value first so re-picking the same file still fires `change`
    fileUpload.value = null;
    fileUpload.click();
  }

  onFileSelected(file: FileList) {
    const picked = file?.item(0);
    if (!picked) {
      return;
    }
    // the upload payload and the preview are set together, so they can never diverge
    this.imageFile = picked;
    this.selectedImage = picked;
    const reader = new FileReader();
    reader.onload = (event: any) => {
      this.image = event.target.result;
    };
    reader.readAsDataURL(picked);
  }

  saveProfile() {
    // this.globalService.startLoading();
    this.loading = true;
    const formData = new FormData();
    for (const i in this.profileForm.value) {
      formData.append(i, this.profileForm.value[i])
    }
    if (this.imageFile !== undefined) {
      formData.append('image', this.imageFile);
    }
    formData.append('platform', 'web');
    formData.append('login_as', localStorage.getItem('loginAs'));

    this.userService.updateProfile(formData).subscribe((res: any) => {
      for (const key of this.currentUserKeys) {
        this.dataService.currentUser[key] = res[key];
      }
      this.profileForm.controls['role_type'].setValue(res.roles.find(role => role.name === localStorage.getItem('loginAs')).name);
      this.dataService.currentUser['role_type'] = res.roles.find(role => role.name === localStorage.getItem('loginAs')).name;
      this.loading = false;
      this.formFlag = 'view';
    }, error => {
      Object.keys(error.error.errors).map(ControlName => {
        this.profileForm.controls[ControlName].setErrors({ 'incorrect': true });
        this.profileForm.controls[ControlName].markAsTouched();
      })
      this.loading = false;
    })
  }

  setTab(value) {
    this.tab = value;
  }

  getPasswordError(control: string) {
    let errorMsg;
    if (this.passwordForm.controls[control].errors) {
      switch (control) {
        case 'old_password':
          errorMsg = this.passwordForm.controls[control].errors.required ? this.translate.instant('profile.old-pass-req') :
            this.translate.instant('profile.old-pass-error')
          break;
        case 'new_password':
          // errorMsg = this.passwordForm.controls[control].errors.required ? this.translate.instant('profile.new-pass-req') :
          //   this.translate.instant('profile.new-pass-error')
           errorMsg = this.passwordForm.controls[control].errors.required ? this.translate.instant('profile.new-pass-req') :
            this.translate.instant('profile.new-pass-error')
          break;
        default:
          break;
      }
    }
    return errorMsg
  }

  changePassword() {
    // this.globalService.startLoading();
    this.loading = true;
    let body = {
      old_password: this.passwordForm.value['old_password'],
      new_password: this.passwordForm.value['new_password']
    }
    this.userService.changePassword(body).subscribe(res => {
      this.passwordForm.reset();
      // this.globalService.stopLoading();
      this.loading = false;
    },
      (error => {
        // this.globalService.stopLoading();
        this.loading = false;
        this.passwordError = error.error.message;
        if (this.passwordError) {
          this.passwordForm.controls['old_password'].setErrors({ 'incorrect': true });
          this.passwordForm.controls['old_password'].markAsTouched();
        }
      }))
  }

  editProfile() {
    this.formFlag = 'edit';
  }

  closeModalHandler() {
    this.tab = 'profile';
    this.formFlag = 'view';
    $('#home-tab').tab('show');
    this.currentPasswordType = 'password'
    this.newPasswordType = 'password'
    this.profileForm.reset();
    this.passwordForm.reset();
    $("#profileModal").modal("hide");
  }

  getProfileFormErrorMessage(control: string) {
    let errorMSG;
    if (this.profileForm.controls[control].errors) {
      switch (control) {
        case 'name':
          errorMSG = this.profileForm.controls[control].errors.required ? this.translate.instant('profile.name-required') :
            this.profileForm.controls[control].errors.incorrect ? this.translate.instant('profile.name-exists') :
              this.translate.instant('profile.name-valid')
          break;


        case 'national_id':
          errorMSG = this.profileForm.controls[control].errors.required ? this.translate.instant('profile.id-required') :
            this.profileForm.controls[control].errors.incorrect ? this.translate.instant('profile.id-exists') :
              this.translate.instant('profile.id-valid')
          break;


        case 'phone':
          errorMSG = this.profileForm.controls[control].errors.required ? this.translate.instant('profile.phone-required') :
            this.profileForm.controls[control].errors.incorrect ? this.translate.instant('profile.phone-exists') :
              this.translate.instant('profile.phone-valid')
          break;

        case 'email':
          errorMSG = this.profileForm.controls[control].errors.required ? this.translate.instant('profile.email-required') :
            this.profileForm.controls[control].errors.incorrect ? this.translate.instant('profile.email-exists') :
              this.translate.instant('profile.email-valid')
          break;
        default:
          break;
      }
    }
    return errorMSG;
  }
}
